module.exports = __webpack_public_path__ + "img/placeholder.d1114bc1.jpg";